import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useMe } from './useMe';
import { SPA_ROUTES, APP_BASE } from '@/lib/paths';

type RequireAuthProps = {
  children: ReactNode;
  requiredRole?: string;
};

export function RequireAuth({ children, requiredRole }: RequireAuthProps) {
  const location = useLocation();
  const { isLoading, isAuthenticated, hasRole } = useMe(location.key);

  if (!isLoading && !isAuthenticated) {
    const returnPath = `${APP_BASE}${location.pathname}`;
    const returnUrl = encodeURIComponent(returnPath + location.search);
    return <Navigate to={`${SPA_ROUTES.LOGIN}?returnUrl=${returnUrl}`} replace />;
  }

  if (!isLoading && requiredRole && !hasRole(requiredRole)) {
    return <Navigate to={SPA_ROUTES.ACCESS_DENIED} replace />;
  }

  return <>{children}</>;
}
